<template>
    <div>
        <transition name="page">
            <v-container class="pa-5" fluid>
                <CostCenterNumberDialog
                    :is-open="costCenterNumberDialog"
                    :cost-center-number-data="costCenterNumber"
                    @on-save="getCostCenterNumbers()"
                    @on-close="closeCostCenterNumberDialog"
                />

                <page-title>Baza MPK</page-title>
                <v-row align="center">
                    <v-col cols="12" lg="4">
                        <v-btn
                            color="secondary"
                            medium
                            data-sentry-label="Dodaj MPK"
                            @click="showCostCenterNumberDialog"
                        >
                            <v-icon left>
                                mdi-plus
                            </v-icon>
                            Dodaj MPK
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-card>
                            <v-data-table
                                :headers="headers"
                                :items="costCenterNumbers"
                                :loading="costCenterNumbersLoading"
                                :footer-props="footerProps"
                                :server-items-length="pagination.itemsLength"
                                :page.sync="pagination.page"
                                :mobile-breakpoint="0"
                                name="costCenterNumbersData"
                                @pagination="updatePagination"
                            >
                                <template #item.actions="{item}">
                                    <div class="d-inline-flex">
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Edytuj"
                                                    v-on="on"
                                                    @click="showEditCostCenterNumberDialog(item)"
                                                >
                                                    <v-icon color="teal">
                                                        mdi-pencil
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Edytuj</span>
                                        </v-tooltip>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </transition>
    </div>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import CostCenterNumberDialog from './CostCenterNumberDialog'
import pagination from '@/mixins/dataTablePagination'
import tooltipDelay from '@/mixins/tooltip'

import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'CostCenterNumberList',
    components: {
        PageTitle,
        CostCenterNumberDialog
    },
    mixins: [
        pagination,
        tooltipDelay,
    ],
    data() {
        return {
            costCenterNumber: {},
            costCenterNumberDialog: false,
            headers: [
                {
                    text: 'Kod',
                    value: 'number',
                    sortable: false
                },
                {
                    text: 'Opis',
                    value: 'description',
                    sortable: false
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 100
                }
            ]
        }
    },
    computed: {
        costCenterNumbers() {
            return this.$store.state.administration.costCenterNumbers.costCenterNumbers
        },
        costCenterNumbersLoading() {
            return this.$store.state.administration.costCenterNumbers.costCenterNumbersLoading
        }
    },
    mounted() {
        this.getCostCenterNumbers()
    },
    methods: {
        getCostCenterNumbers() {
            this.$store.dispatch('administration/getCostCenterNumbers', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        showCostCenterNumberDialog() {
            this.costCenterNumberDialog = true

        },
        showEditCostCenterNumberDialog(costCenterNumber) {
            this.costCenterNumber = costCenterNumber
            this.costCenterNumberDialog = true

        },
        closeCostCenterNumberDialog() {
            this.costCenterNumberDialog = false

            setTimeout(() => {
                this.costCenterNumber = {}
            }, 500)
        },
        updatePagination(pagination) {
            this.pagination = pagination
            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getCostCenterNumbers()
            }
            this.clearPaginationPending()
        }
    }
}
</script>
